import { defineNuxtPlugin } from '#app/nuxt'
import { LazyButton, LazyDataTable, LazyDialog, LazyDrawer, LazyCarousel } from '#components'
const lazyGlobalComponents = [
  ["Button", LazyButton],
["DataTable", LazyDataTable],
["Dialog", LazyDialog],
["Drawer", LazyDrawer],
["Carousel", LazyCarousel],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
